export const Select = {
  DEFAULT: {
    EMPTY: "Нічого немає",
    LOADING: "Шукаю...",
    PLACEHOLDER: "Оберіть один з варіантів",
  },
};
